import { useState, useRef, useCallback, useEffect, useLayoutEffect } from 'react'
import { stopEvent } from '@aytm/lib/common/func'
import { itemTypeFromEvent } from '@aytm/lib/adnd/ADNDHelpers'

const useDrag = (root, isVisible) => {
  const [isDragging, setIsDragging] = useState(false)

  const rootRef = useRef(root)

  const onDragLeaveHandler = useCallback(() => {
    setIsDragging(false)
  }, [])

  const onDragOverHandler = useCallback(event => {
    const type = itemTypeFromEvent(event)
    if ('sidebar-tag' != type) return

    const currentRoot = rootRef.current
    if (!currentRoot) return

    const rootRect = currentRoot.getBoundingClientRect()

    if (
      event.clientY >= rootRect.top &&
      event.clientY <= rootRect.top + rootRect.height &&
      event.clientX >= rootRect.x &&
      event.clientX <= rootRect.x + rootRect.width
    ) {
      setIsDragging(true)

      if (
        event.clientY >= rootRect.top &&
        event.clientY <= rootRect.top + 80 &&
        event.clientX >= rootRect.x &&
        event.clientX <= rootRect.x + rootRect.width
      ) {
        currentRoot.scrollBy(0, -10)
      }

      if (
        event.clientY >= rootRect.top + rootRect.height - 80 &&
        event.clientY <= rootRect.top + rootRect.height &&
        event.clientX >= rootRect.x &&
        event.clientX <= rootRect.x + rootRect.width
      ) {
        currentRoot.scrollBy(0, 10)
      }
    } else setIsDragging(false)
  }, [])

  // Keep rootRef current to avoid stale closures
  useEffect(() => {
    rootRef.current = root
  }, [root])

  useEffect(() => {
    if (isVisible) {
      document.addEventListener('dragover', onDragOverHandler)
    } else {
      onDragLeaveHandler()

      document.removeEventListener('dragover', onDragOverHandler)
    }

    return () => {
      onDragLeaveHandler()

      document.removeEventListener('dragover', onDragOverHandler)
    }
  }, [isVisible, onDragOverHandler, onDragLeaveHandler])

  useLayoutEffect(() => {
    const currentScrollY = window.scrollY

    const preventDocumentScroll = event => {
      stopEvent(event)

      window.scrollTo({ top: currentScrollY, behavior: 'instant' })
      // window.scrollTo({ top: currentScrollY })
    }

    if (isDragging) {
      document.addEventListener('scroll', preventDocumentScroll, true)
      document.addEventListener('dragleave', onDragLeaveHandler)
      document.addEventListener('dragend', onDragLeaveHandler)
    } else {
      document.removeEventListener('scroll', preventDocumentScroll, true)
      document.removeEventListener('dragleave', onDragLeaveHandler)
      document.removeEventListener('dragend', onDragLeaveHandler)
    }

    return () => {
      document.removeEventListener('scroll', preventDocumentScroll, true)
      document.removeEventListener('dragleave', onDragLeaveHandler)
      document.removeEventListener('dragend', onDragLeaveHandler)
    }
  }, [isDragging])
}

export default useDrag
